/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { Field, Formik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import RestlessDisplayProperty from "../../../../app/components/common/RestlessDisplayProperty";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../redux/actions/users";

export default function RestlessModerationModal({
  show,
  id,
  onHide,
  onSubmit,
  row,
  article,
  user,
  entityType,
}) {

  const {
    userForDetails
  } = useSelector(
    (state) => ({
      userForDetails: state.users2.userForDetails,
    })
  );

  const dispatch = useDispatch()
  const [userInfo, setUserInfo] = useState()

  const initialValues = {
    comments: "",
    reasons: null,
    article: false,
    moderateUser: !!user,
    shadowban: row?.shadowbanned,
    userAction: '',
    notifications: [],
    prevState: false,
    id: id,
  };

  const ModerationSchema = Yup.object().shape({
    comments: Yup.string().max(50, "Maximum 50 characters"),
    reasons: !user
      ? Yup.string()
          .required("Reasons is a required field.")
          .nullable()
      : Yup.string().nullable(),
    artcile: Yup.boolean(),
    moderateUser: Yup.boolean(),
    userAction: Yup.string(),
    toverified: Yup.boolean(),
    toadmin: Yup.string(),
    unshadowbanned: Yup.string(),
    reenable: Yup.string(),
  });

  useEffect(() => {
    if (entityType != 'User'){
      dispatch(actions.fetchUser(id));
    } else {
      setUserInfo(row)
    }
  },[row])

  useEffect(() => {
    if (entityType != 'User' && userForDetails){
      setUserInfo(userForDetails)
    }
  },[userForDetails])

  const getInputClasses = (fieldname, touched, errors) => {
    if (touched[fieldname] && errors[fieldname]) {
      return "is-invalid";
    }
    return "";
  };

  const renderModerateUser = (values) => {
    return (
      <>
        <div className="row mb-4">
          <div className="col">
            <RestlessDisplayProperty label="Name" content={userInfo?.full_name } />
          </div>
          <div className="col">
            <RestlessDisplayProperty label="Email" content={userInfo?.email} />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col">
            <RestlessDisplayProperty label="Role" content={userInfo?.status} />
          </div>
          <div className="col">
            <RestlessDisplayProperty
              label="Is Shadowbanned?"
              content={userInfo?.shadowbanned ? "Yes" : "No"}
            />
          </div>
        </div>
        <hr />
        <div className="mb-2" id="user-actions">
          Moderation Actions
        </div>
        <div className="row mb-2">
          <div className="col">
            <div>
              <label>
                <Field
                  type="radio"
                  name="userAction"
                  value="DISABLED"
                  className="mx-2"
                  disabled={userInfo?.status == "DEACTIVATED" ||  userInfo?.status == "DISABLED"}
                />
                Disable
              </label>
            </div>
            <div>
              <label>
                <Field
                  type="radio"
                  name="userAction"
                  value="KICKEDOUT"
                  className="mx-2"
                  disabled={
                    userInfo?.status == "DISABLED" || userInfo?.status == "DEACTIVATED"
                  }
                />
                Kick out
              </label>
            </div>
            <div>
              <label>
                <Field
                  type="radio"
                  name="userAction"
                  value="SHADOWBAN"
                  className="mx-2"
                  disabled={
                    userInfo?.status == "DISABLED" ||
                    userInfo?.status == "DEACTIVATED" ||
                    userInfo?.status == "ADMIN" ||
                    userInfo?.shadowbanned
                  }
                />
                Shadowban
              </label>
            </div>
          </div>
          <div className="col">
            <div>
              <label>
                <Field
                  type="radio"
                  name="userAction"
                  value="REENABLE"
                  className="mx-2"
                  disabled={
                    userInfo?.status != "DISABLED" && userInfo?.status != "DEACTIVATED"
                  }
                />
                Re-Enable
              </label>
            </div>
            <div>
              <label>
                <Field
                  type="radio"
                  value="UNSHADOWBANNED"
                  name="userAction"
                  className="mx-2"
                  disabled={
                    row?.status == "DISABLED" ||
                    row?.status == "DEACTIVATED" ||
                    row?.status == "ADMIN"  ||
                    !row?.shadowbanned
                  }
                />
                Un-shadowban
              </label>
            </div>
          </div>
        </div>
        <div className="row mb-2">
          <div className="col">
            <div className="mb-2" id="user-actions">
              Set Role
            </div>
            <div>
              <label>
                <Field
                  type="radio"
                  name="userAction"
                  value="VERIFIED"
                  className="mx-2"
                  disabled={
                    userInfo?.status == "DISABLED" ||
                    userInfo?.status == "DEACTIVATED" ||
                    userInfo?.status == "VERIFIED"
                  }
                />
                Verified
              </label>
            </div>
            <div>
              <label>
                <Field
                  type="radio"
                  name="userAction"
                  value="ADMIN"
                  className="mx-2"
                  disabled={
                    userInfo?.status == "DISABLED" ||
                    userInfo?.status == "DEACTIVATED" ||
                    userInfo?.status == "ADMIN" || userInfo?.shadowbanned
                  }
                />
                Admin
              </label>
            </div>
          </div>
        </div>
      </>
    );
  };

  function renderReasons() {
    return (
      <div role="group" aria-labelledby="reasons-group" className="col">
        <div>
          <label>
            <Field
              type="radio"
              name="reasons"
              value="Harassment"
              className="mx-2"
            />
            Harassment
          </label>
        </div>
        <div>
          <label>
            <Field
              type="radio"
              name="reasons"
              value="Inappropiate Content"
              className="mx-2"
            />
            Inappropiate Content
          </label>
        </div>
        <div>
          <label>
            <Field type="radio" name="reasons" value="Spam" className="mx-2" />
            Spam
          </label>
        </div>
        <div>
          <label>
            <Field type="radio" name="reasons" value="MLM" className="mx-2" />
            MLM
          </label>
        </div>
        <div>
          <label>
            <Field
              type="radio"
              name="reasons"
              value="Creepy Dude"
              className="mx-2"
            />
            Creepy Dude
          </label>
        </div>
        <div>
          <label>
            <Field
              type="radio"
              name="reasons"
              value="Graphic"
              className="mx-2"
            />
            Graphic
          </label>
        </div>
      </div>
    );
  }

  return (
    <>
      <Modal size="lg" show={show} onHide={onHide}>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => onSubmit(values, row)}
          validationSchema={!row?.hashtag && ModerationSchema}
        >
          {({
            values,
            errors,
            handleChange,
            status,
            touched,
            handleSubmit,
            getFieldProps,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header>
                <div className="">
                  {entityType == "User"
                    ? "Edit Role"
                    : "Moderate" + entityType
                    ? entityType
                    : "Entity"}
                </div>
              </Modal.Header>
              <Modal.Body>
                {user ? (
                  <>
                    <div className="container">
                      {renderModerateUser(userForDetails)}
                    </div>
                  </>
                ) : (
                  <>
                    {!row?.hashtag ? (
                      <>
                        {errors.reasons ? (
                          <div className="mb-10 justify-content-center alert alert-custom alert-light-danger alert-dismissible">
                            <div className="alert-text font-weight-bold text-center">
                              {errors.reasons}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        <div className="container">
                          <div className="row mb-4">
                            <div className="col-4">
                              <Form.Label>Reason</Form.Label>
                              {renderReasons()}
                            </div>
                            <div className="col-8">
                              <div className="row mb-4">
                                <div className="col">
                                  <Form.Label>Action</Form.Label>
                                  {article ? (
                                    <>
                                      <div>
                                        <label>
                                          <Field
                                            type="checkbox"
                                            name="deleteArticle"
                                            className="mx-2"
                                          />
                                          Delete Article
                                        </label>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div>
                                        <label>
                                          <Field
                                            type="checkbox"
                                            name="moderateUser"
                                            className="mx-2"
                                          />
                                          Edit Roles
                                        </label>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col">
                                  {values.moderateUser &&
                                    renderModerateUser(values)}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col">
                              <Form.Control
                                as="textarea"
                                name="comments"
                                values={values.comments}
                                onChange={handleChange}
                                type="text"
                                placeholder="Comments"
                                rows={5}
                                className={getInputClasses(
                                  "comments",
                                  touched,
                                  errors
                                )}
                                {...getFieldProps("comments")}
                                maxLength={50}
                              />
                              <div className="d-flex justify-content-end">
                                {values.comments.length}/50
                              </div>
                            </div>
                          </div>
                          <div className="row mb-4">
                            {!values.moderateUser && (
                              <>
                                <div className="col-6">
                                  <label>
                                    <Field
                                      type="checkbox"
                                      name="notifications"
                                      value="Send push"
                                      className="mx-2"
                                      disabled={values.moderateUser}
                                    />
                                    Send push notification
                                  </label>
                                </div>
                                <div className="col-6">
                                  <label>
                                    <Field
                                      type="checkbox"
                                      name="notifications"
                                      value="Send email"
                                      className="mx-2"
                                      disabled={values.moderateUser}
                                    />
                                    Send email notification
                                  </label>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {row.banned ? (
                          <div className="d-flex justify-content-center">
                            Do you want to unban <strong>{row.hashtag} </strong>
                            ?
                          </div>
                        ) : (
                          <div className="d-flex justify-content-center">
                            <div>
                              Do you want to ban <strong>{row.hashtag} </strong>
                              ?{" "}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button className="btn btn-secondary" onClick={onHide}>
                  Cancel
                </Button>
                <Button
                  className="btn btn-secondary"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Accept
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
